// Auto-updated build version — bump this on each deploy/significant change
// Format: vYYYY.MM.DD-HH:MM
export const BUILD_VERSION = "v2026.05.10-06:00";
export const BUILD_NOTE = "$0.20/credit pricing; bonus 30->20; daily-free 1->2/24h; subscription hidden; signup-bonus hidden; WitnessStandTabs everywhere; rename Inspiration->Submit Testimony";
